// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
const state = {
  sort: 'asc',
}

const mutations = {
  setSort(state, sort) {
    state.sort = sort
  },
  resetSetting(state) {
    state.sort = 'asc'
  },
}

const getters = {
  sort(state) {
    return state.sort
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
